<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <piaf-breadcrumb :heading="$t('menu.shop-register-request')" />
            <div class="separator mb-5"></div>
        </b-colxx>
    </b-row>

    <!-- 주소검색 -->
    <modal_postcode ref="modal_postcode" @confirm="selectAddress" />
    <modal_image ref="modal_image" :data="this.form.registrationNumberUrl" />

    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="매장 정보 입력">

                <b-form-group label-cols="2" horizontal :label="$t('store.name')">
                    <b-input-group class="col-9 pl-0">
                        <b-form-input placeholder="매장명" v-model="form.storeName" type="text"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary" :disabled="overlapCheck" @click="duplicationCheck">
                                {{ $t('button.overlap-check') }}
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="$t('store.address')">
                    <b-input-group class="col-9 pl-0">
                        <b-form-input placeholder="" type="text" v-model="form.address3" disabled></b-form-input>
                        <b-form-input placeholder="" type="text" v-model="form.detailAddress"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="searchAddress">{{ $t('button.search-address') }}</b-button>
                        </b-input-group-append>

                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="$t('store.type')">
                    <v-select size="lg" :options="storeTypeOptions" placeholder="업종선택하세요" v-model="form.storeType" style="width:30%;"></v-select>
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="$t('store.registrationNumber')">
                    <b-input-group class="mb-3 col-9 pl-0 fileInputSize">
                        <b-form-input v-model="form.registrationNumber" placeholder="사업자등록번호" class="mr-3"></b-form-input>
                        <b-form-file accept="image/*" :browse-text="browseText" v-model="form.registrationNumberFile" :placeholder="placeholderImg"></b-form-file>

                        <b-input-group-append v-if=" form.registrationNumberFile != null">
                            <b-button class="fileCustomBtn" variant="outline-secondary" @click="getBusinessLicenseImage" >미리보기</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <div class="text-center">
                    <b-button variant="outline-primary" class="mt-4" @click.prevent="onCancel()">취소</b-button>
                    <b-button v-if="!isRegisted" variant="primary" class="mt-4 ml-2" @click.prevent="tempRegisterRequest()">임시저장
                    </b-button>
                    <b-button v-if="!isRegisted" type="submit" variant="success" class="mt-4 ml-2" @click.prevent="registerRequest()">등록 신청
                    </b-button>
                    <b-button v-if="isRegisted" type="submit" variant="warning" class="mt-4 ml-2" @click.prevent="onCancelRegisterRequest()">등록신청 취소
                    </b-button>
                </div>
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import api from '../../constants/api'
// import SortableFileUploader from "../../components/Upload/SortableFileUploader.vue";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ModalPostcode from './components/ModalPostcode'
import ModalImage from './components/ModalImage'
import Axios from 'axios'
import {
    storeTypeList,
    eventBus
} from '../../utils'

const {
    BlobServiceClient,
    ContainerClient
} = require('@azure/storage-blob');

export default {
    components: {
        // 'sortable-file-uploader': SortableFileUploader,
        'v-select': vSelect,
        'modal_postcode': ModalPostcode,
        'modal_image': ModalImage
    },
    data() {
        return {
            browseText: '등록',
            address: {},
            form: {
                zone1: '',
                zone2: '',
                storeCode: '',
                storeName: '',
                address1: '',
                address2: '',
                address3: '',
                detailAddress: '',
                zipCode: '',
                storeType: '',
                registrationNumber: '',
                registrationNumberFile: null,
                registrationNumberUrl: '',
                corporationName: '',
                phone: '',
                email: '',
                representative: '',
                region: '',
                city: '',

            },
            modifyMode: false, //수정 모드
            isRegisted: false, // 이미 등록된
            registFlag: false, // 등록신청 구분
            overlapCheck: false,
            placeholderImg: '파일을 선택하세요...',
            storeTypeOptions: [],
            zone1Options: [{
                text: '--대분류--',
                value: '',
                disabled: true
            }],
            zone2Options: [{
                text: '--소분류--',
                value: '',
                disabled: true
            }],
            flag: true,
        }
    },

    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    created(){
        this.getStoreType();
    },
    mounted() {
        // this.getstoreAreas()

        if (this.$route.params.storeCode) { //수정
            this.form.storeCode = this.$route.params.storeCode
            this.modifyMode = true
            this.overlapCheck = true
            this.loadData()
        }

    },

    watch: {
        'form.storeName'(value) {
            this.overlapCheck = false
        },

        'form.registrationNumber'(value) {
            if (!new RegExp(/^[\d() \.\:\-\+#]+$/).test(value) && value !='' ) {
                alert("숫자만 입력이 가능합니다.");

            }
        },

        'form.registrationNumberFile'(value) {
            console.log(value);
            this.browseText = this.form.registrationNumberFile == null ? '등록' : "수정"

            if (value.type != undefined) {
                const azureInfo = this.AzureFileUpload();
                console.log(azureInfo)
            }

        }
    },

    methods: {

        getStoreType() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeType)
            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                this.storeTypeOptions = [];
                res.data.data.types.forEach(el => {
                    this.storeTypeOptions.push({
                        label: el.typeName,
                        value: el.storeType,
                    })
                });
            }).catch(err => {

            })
        },

        getBusinessLicenseImage: function () {
            this.popupImage()
        },

        /** *************************************************************************************************************/
        loadData: function () {

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.registerInfo)
            const params = {
                storeRegisterId: this.form.storeCode
            }

            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {

                    const data = res.data.data

                    if (data.registerStatus == "RegRequested") { //등록신청중
                        this.isRegisted = true
                    } else if (data.registerStatus == "NoRequest") { //임시저장

                    }
                    this.placeholderImg = data.basicInfo.registrationNumberUrl.substr(0, 40)
                    this.form.storeName = data.basicInfo.storeName
                    // this.form.corporationName = data.basicInfo.corporationName
                    // this.form.representative = data.basicInfo.representative
                    // this.form.phone = data.basicInfo.phone1
                    // this.form.email = data.basicInfo.email
                    this.form.storeType = this.storeTypeOptions.find(x => x.value === data.basicInfo.storeType)
                    this.form.registrationNumber = data.basicInfo.registrationNumber
                    this.form.registrationNumberUrl = data.basicInfo.registrationNumberUrl

                    this.form.registrationNumberFile = {
                        name: "TestName.jpg",
                        url: data.basicInfo.registrationNumberUrl,
                    }

                    this.address.roadAddress = data.address.roadAddress
                    this.address.jibunAddress = data.address.jibunAddress
                    this.address.engAddress = data.address.engAddress
                    this.address.zipCode = data.address.zipCode
                    this.address.coordinateSystem = data.address.coordinateSystem
                    this.address.longitude = data.address.coordinateX
                    this.address.latitude = data.address.coordinateY
                    this.form.address3 = data.address.roadAddress
                    this.form.detailAddress = data.address.detailAddress;
                    this.address.region = data.address.region;
                    this.address.city = data.address.city;
                    // console.log(data.address)
                    // this.mainAreaNum = data.address.mainAreaNum
                    // this.middleAreaNum = data.address.middleAreaNum


                } else {
                    throw 400
                }
            }).catch(err => {
                // this.$router.go(-1)
                return false
            })

        },

        /** *************************************************************************************************************/
        //임시저장
        async tempRegisterRequest() {
            console.log(this.address)
            this.registFlag = false
            if (this.form.storeName === "") {
                alert('매장명을 입력해주세요')
                return false
            } else if (!this.overlapCheck) {
                alert('매장명을 중복확인 해주세요.')
                return false
            } else if (this.address.roadAddress === null) {
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else if (this.address.jibunAddress === null) {
                alert('상세주소를 입력해주세요')
                return false
            } else if (this.address.zipCode === null) {
                alert('상세주소를 입력해주세요')
                return false
            } else if (this.form.storeType === "") {
                alert('업종을 선택해주세요.')
                return false
            } else if (this.form.registrationNumber == "") {
                alert('사업자 등록번호를 입력해주세요.')
                return false
            } else if (this.form.registrationNumberUrl == "") {
                alert('사업자 등록증 파일을 첨부해주세요 ')
                return false
            } else if (this.form.registrationNumberFile == null) {
                alert('사업자 등록증 파일을 첨부해주세요 ')
                return false
            } else if (this.address.longitude == null) {
                // alert('x좌표가 없습니다.')
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else if (this.address.latitude == null) {
                // alert('y좌표가 없습니다.')
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else {
                let reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.draftCreate)

                const address = {
                    roadAddress: this.address.roadAddress,
                    jibunAddress: this.address.jibunAddress,
                    detailAddress: this.form.detailAddress,
                    engAddress: this.address.engAddress,
                    zipCode: this.address.zipCode,
                    coordinateX: Number(this.address.longitude),
                    coordinateY: Number(this.address.latitude),
                    coordinateSystem: 'EPSG4326',
                    region : this.address.region,
                    city : this.address.city,

                }

                const params = {
                    address: address,
                    basicInfo: {
                        storeName: this.form.storeName,
                        storeType: this.form.storeType.value,
                        registrationNumber: this.form.registrationNumber,
                        registrationNumberUrl: this.form.registrationNumberUrl,
                    }

                }
                // console.log(params)

                if (this.modifyMode) { //수정시 수정모드
                    reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.update)
                    Object.assign(params, {
                        storeRegisterId: this.form.storeCode
                    })
                }

                eventBus.$emit('bus-event', true);
                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    eventBus.$emit('bus-event', false);
                    alert('적용했습니다.')
                    this.$router.push(`/${this.siteName}/shop/shop-register-status`)

                    // console.log(res)

                }).catch(err => {
                    eventBus.$emit('bus-event', false);
                    alert(err.response.data.message);
                })

            }
        },

        /** *************************************************************************************************************/
        //등록요청
        registerRequest() {
            this.registFlag = true
            this.onRegisterRequest()
        },

        //등록신청
        async onRegisterRequest() {

            if (this.form.storeName === "") {
                alert('매장명을 입력해주세요')
                return false
            } else if (!this.overlapCheck) {
                alert('매장명을 중복확인 해주세요.')
                return false
            } else if (this.address.roadAddress === null) {
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else if (this.address.jibunAddress === null) {
                alert('상세주소를 입력해주세요')
                return false
            } else if (this.address.zipCode === null) {
                alert('상세주소를 입력해주세요')
                return false
            } else if (this.form.storeType === "") {
                alert('업종을 선택해주세요.')
                return false
            } else if (this.form.registrationNumber == "") {
                alert('사업자 등록번호를 입력해주세요.')
                return false
            } else if (this.form.registrationNumberUrl == "") {
                alert('사업자 등록번호사본 URL를 입력해주세요.')
                return false
            } else if (this.form.registrationNumberFile == null) {
                alert('첨부파일을 등록해 주세요.')
                return false
            } else if (this.address.longitude == null) {
                // alert('x좌표가 없습니다.')
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else if (this.address.latitude == null) {
                // alert('y좌표가 없습니다.')
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else {

                const address = {
                    roadAddress: this.address.roadAddress,
                    jibunAddress: this.address.jibunAddress,
                    detailAddress: this.form.detailAddress,
                    engAddress: this.address.engAddress,
                    zipCode: this.address.zipCode,
                    coordinateX: Number(this.address.longitude),
                    coordinateY: Number(this.address.latitude),
                    coordinateSystem: 'EPSG4326',
                    region : this.address.region,
                    city : this.address.city,

                }

                const params = {
                    address: address,
                    basicInfo: {
                        storeName: this.form.storeName,
                        storeType: this.form.storeType.value,
                        registrationNumber: this.form.registrationNumber,
                        registrationNumberUrl: this.form.registrationNumberUrl
                    }
                }

                let reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.create)

                if (this.modifyMode) { //수정시 수정모드
                    Object.assign(params, {
                        storeRegisterId: this.form.storeCode
                    })
                    if (this.form.storeCode == null) {
                        alert("매장등록 요청 ID가 없습니다.")
                        return
                    }
                }

                // console.log(params)

                eventBus.$emit('bus-event', true);
                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    eventBus.$emit('bus-event', false);
                    this.isRegisted = true
                    alert('매장등록 신청이 완료 되었습니다.')
                    this.$router.push(`/${this.siteName}/shop/shop-register-status`)
                }).catch(err => {
                    eventBus.$emit('bus-event', false);
                    alert(err.response.data.message);
                })

            }
        },

        /** *************************************************************************************************************/
        //등록신청취소
        onCancelRegisterRequest() {

            const num = Number(this.form.storeCode)

            // console.log(num)
            const params = {
                storeRegisterId: num
            }

            let reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.reqCancel)

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {

                alert('매장등록 신청이 취소 되었습니다.')
                this.$router.push(`/${this.siteName}/shop/shop-register-status`)
            }).catch(err => {
                alert(err.response.data.message);
            })

        },

        /** *************************************************************************************************************/
        //매장명 중복확인
        duplicationCheck() {
            if (this.form.storeName.length < 2) {
                alert('매장명을 2자 이상 입력하세요.')
                return false
            }
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.exists)
            const params = {
                storeName: this.form.storeName
            }
            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                this.overlapCheck = !res.data.data
                if (res.data.data === false) {
                    alert("사용 가능한 매장명 입니다.")
                } else {
                    alert("이미 사용중인 매장명 입니다")
                    this.form.storeName = '' //초기화
                }
            }).catch(err => {
                alert(err.response.data.message);
                this.overlapCheck = false
            })
        },

        searchAddress() {
            this.$refs.modal_postcode.open()
        },

        popupImage() {
            this.$refs.modal_image.open()
        },

        selectAddress(data) {
            this.form.address3 = data.data.roadAddress
            this.form.detailAddress = data.data.detailAddress
            this.address = data.data;
            // console.log(data)
        },

        //취소
        onCancel() {
            this.$router.push(`/${this.siteName}/shop/shop-register-status`)
        },

        AzureFileUpload() {
            const vm = this;

            return new Promise(function (resolve, reject) {

                let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
                let params = {
                    type: "STORE"
                }

                vm.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        let containerUrl = res.data.data.url
                        const containerClient = new ContainerClient(containerUrl);

                        const file = vm.form.registrationNumberFile;

                        // console.log(`${res.data.data.directory}`);
                        // console.log(`${file.name}`);
                        // console.log(`${res.data.data.directory}/${file.name}`);

                        const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${file.name}`);

                        blockBlobClient.uploadBrowserData(file, {
                            blockSize: 4 * 1024 * 1024, // 4MB block size
                            blobHTTPHeaders: {
                                blobContentType: file.type
                            }
                        }).then(success => {
                            console.log("success", success)
                            let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
                            vm.form.registrationNumberUrl = uploadedUrl
                            console.log(vm.form.registrationNumberUrl);

                        }).catch(reason => {
                            alert("업로드 실패")
                        })

                        resolve('sss');

                    } else {
                        throw 400
                    }
                }).catch(err => {
                    reject(new Error('업로드 실패'));
                });
            })

        },

        test(event) {
            console.log('progress')
            console.log(event)
        },
        test2(event) {
            console.log('complete')
            console.log(event)
        },
        test3(event) {
            console.log('eerrr')
            console.log(event)
        },

    } //method
}
</script>
